import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, Lock, AlertCircle } from 'lucide-react';
import { config } from '../../config';
import './AdminLogin.css';

const AdminLogin: React.FC = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const API_URL = config.apiUrl;

    try {
      // New JWT-based login
      const response = await fetch(`${API_URL}/admin/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ password }),
      });

      if (response.ok) {
        const data = await response.json();
        // Store JWT token (NOT password)
        localStorage.setItem('admin_token', data.admin_token);
        localStorage.setItem('admin_expires_at', data.expires_at.toString());
        localStorage.setItem('admin_logged_in', 'true');
        navigate('/admin/dashboard');
      } else {
        const errorData = await response.json();
        setError(errorData.error || 'Invalid admin password');
      }
    } catch (err) {
      setError('Failed to connect to server');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-container">
        <div className="admin-login-card">
          <div className="admin-login-header">
            <div className="admin-icon">
              <Shield size={32} />
            </div>
            <h1>Admin Access</h1>
            <p>Enter admin password to continue</p>
          </div>

          <form onSubmit={handleLogin} className="admin-login-form">
            {error && (
              <div className="alert alert-error">
                <AlertCircle size={20} />
                <span>{error}</span>
              </div>
            )}

            <div className="form-group">
              <label>Admin Password</label>
              <div className="password-input">
                <Lock size={20} />
                <input
                  type="password"
                  className="form-control"
                  placeholder="Enter admin password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoFocus
                />
              </div>
            </div>

            <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
              {loading ? 'Verifying...' : 'Access Admin Panel'}
            </button>
          </form>

          <div className="admin-login-footer">
            <p>⚠️ Authorized personnel only</p>
            <a href="/" className="back-link">← Back to Home</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;